export const TITLE = "Usuários Cadastrados";
export const NAME = "Nome";
export const EMAIL = "Email";
export const SHOW_LABEL = "Exibir";

export const USER_ROLE_TYPE = [
  {
    value: "admin",
    label: "Administrador",
  },
  {
    value: "Gerente",
    label: "Gerente",
  },
  {
    value: "Supervisor",
    label: "Supervisor",
  },
  {
    value: "Atendente",
    label: "Atendente",
  },
];

export const USER_ACTIVE_ACCOUNT = [
  {
    value: true,
    label: "Sim",
  },
  {
    type: false,
    label: "Não",
  },
];

export const USER_SERVICES_VALUES = {
  DEFAULT: "default",
  CLASSIFICA_AI: "classifica_ai",
  ARQUIVA_MIX: "arquiva_mix",
};

export const USER_SERVICES_LABELS = {
  DEFAULT: "Padrão",
  CLASSIFICA_AI: "Classifica AI",
  ARQUIVA_MIX: "Arquiva MIX",
};

export const USER_SERVICES = [
  { label: USER_SERVICES_LABELS.DEFAULT, value: USER_SERVICES_VALUES.DEFAULT },
  {
    label: USER_SERVICES_LABELS.CLASSIFICA_AI,
    value: USER_SERVICES_VALUES.CLASSIFICA_AI,
  },
  {
    label: USER_SERVICES_LABELS.ARQUIVA_MIX,
    value: USER_SERVICES_VALUES.ARQUIVA_MIX,
  },
];
